import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";

function NavigationStep(props) {
    const navigate = useNavigate();
    const { search } = useLocation();

    const showNext = props.showNext ?? true;
    const buttonCount = [showNext, props.showReset, props.prevRoute].filter((bool) => bool === true).length;

    const handlePrevious = () => {
        navigate({ pathname: props.prevRoute, replace: false, preserveSearch: true, search });
    }

    return (
        <div className="container mt-4">
            <div className={buttonCount > 1 ? "button-container" : ""}>
                {props.prevRoute && (
                    <div style={!props.showReset && !props.showNext ? { float: 'left' } : {}}>
                        <ButtonComponent tabIndex="1" iconCss='e-icons e-chevron-left' iconPosition='Left' type="button" onClick={handlePrevious}>Back</ButtonComponent>
                    </div>)}

                {props.showReset && (<div style={{ float: 'right' }}>
                    <ButtonComponent tabIndex="2" iconCss='e-icons e-repeat' iconPosition='Right' type="button" onClick={props.handleReset}>{props.resetLabel ? props.resetLabel : 'Reset'}</ButtonComponent>
                </div>)}

                {showNext && (
                    <div style={{ float: 'right' }}>
                        <ButtonComponent tabIndex="0" iconCss='e-icons e-chevron-right' iconPosition='Right' type="submit" isPrimary>{props.nextLabel ? props.nextLabel : 'Next'}</ButtonComponent>
                    </div>)
                }
            </div>
        </div>
    );
}

export default NavigationStep;